// Login / session entrypoint config — mirrors NPI's entrypoint/config.ts +
// app/config.ts, adapted to svet's single-SPA setup (served at `/`, not `/app`).
//
// Tokens are placeholders the worker's api-proxy swaps:
//   - prod: `__LOGIN_TOKEN__` / `__SESSION_TOKEN__` (proxy → real login token
//     from env / real session token from the CONTEMBER_TOKEN cookie)
//   - dev:  the local docker login/root tokens, so dev needs no login flow

const isProd = import.meta.env.PROD

export const SESSION_TOKEN_PLACEHOLDER = '__SESSION_TOKEN__'
export const LOGIN_TOKEN_PLACEHOLDER = '__LOGIN_TOKEN__'

export function getApiBaseUrl(): string {
	// react-client posts to `${apiBaseUrl}/content/<project>/<stage>` and
	// `${apiBaseUrl}/tenant`; the worker proxy strips the `/_api` prefix.
	if (typeof window !== 'undefined') return `${window.location.origin}/_api`
	return '/_api'
}

export const adminConfig = {
	get apiBaseUrl() {
		return getApiBaseUrl()
	},
	projectName: import.meta.env.VITE_CONTEMBER_PROJECT_NAME ?? 'app',
	stage: 'live',
	loginToken: isProd
		? LOGIN_TOKEN_PLACEHOLDER
		: (import.meta.env.VITE_CONTEMBER_LOGIN_TOKEN ?? '1111111111111111111111111111111111111111'),
	sessionToken: isProd ? SESSION_TOKEN_PLACEHOLDER : '0000000000000000000000000000000000000000',
	appUrl: '/',
	loginUrl: '/login',
	// In dev the session token is the local root token (no Person attached),
	// so the login gate is bypassed and the SPA talks to local Contember.
	requireLogin: isProd,
}
